<template>
    <div>
        <slot />
    </div>
</template>

<script>
import Plyr from 'plyr';

export default {
    props: {
        /** Array of events to emit from the plyr object **/
        emit: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            player: {},
            options: {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
            }
        };
    },

    computed: {
        opts() {
            const options = this.options;
            if (!this.options.hasOwnProperty('hideYouTubeDOMError')) {
                options.hideYouTubeDOMError = true;
            }
            return options;
        }
    },

    mounted() {
        this.player = new Plyr(this.$el.firstChild, this.options);
        this.emit.forEach(element => {
            this.player.on(element, this.emitPlayerEvent);
        });

        if (this.$parent.sound) {
            this.player.on('play', () => {
                this.$parent.pause();
            });

            this.player.on('pause', () => {
                this.$parent.play();
            });
        }
    },

    beforeDestroy() {
        try {
            this.player.destroy();

        } catch (e) {
            if (!(this.opts.hideYouTubeDOMError && e.message === 'The YouTube player is not attached to the DOM.')) {
                console.error(e);
            }
        }
    },

    methods: {
        emitPlayerEvent(event) {
            this.$emit(event.type, event);
        }
    }
};
</script>
